type GroupableInput = {
  id: string;
};

export function toObjectMap<TIn extends GroupableInput>(
  arr: TIn[]
): {
  [id: string]: TIn;
} {
  return arr.reduce((acc, next) => {
    acc[next.id] = next;

    return acc;
  }, {});
}
